"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var MediaManagerImage_1 = require("@sportnet/ui/lib/MediaManagerImage");
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var react_1 = tslib_1.__importStar(require("react"));
var react_image_lightbox_1 = tslib_1.__importDefault(require("react-image-lightbox"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var LoadableImg_1 = tslib_1.__importDefault(require("./LoadableImg"));
var SIZE = 70;
var Div = styled_components_1["default"]('div')(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin: 2px;\n  position: relative;\n"], ["\n  margin: 2px;\n  position: relative;\n"])));
var Img = styled_components_1["default"](LoadableImg_1["default"])(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  width: 100%;\n  vertical-align: bottom;\n  cursor: pointer;\n"], ["\n  position: absolute;\n  top: 0;\n  width: 100%;\n  vertical-align: bottom;\n  cursor: pointer;\n"])));
var I = styled_components_1["default"]('i')(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: block;\n"], ["\n  display: block;\n"])));
var Section = styled_components_1["default"]('section')(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n\n  &::after {\n    content: '';\n    flex-grow: 999999999;\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n\n  &::after {\n    content: '';\n    flex-grow: 999999999;\n  }\n"])));
function WidgetPhotoGallery(props) {
    var data = props.data, onChangePhoto = props.onChangePhoto, renderEmpty = props.renderEmpty;
    var pictures = data.pictures || [];
    var _a = react_1.useState({}), imgs = _a[0], setImgs = _a[1];
    var _b = react_1.useState(0), photoIndex = _b[0], setPhotoIndex = _b[1];
    var _c = react_1.useState(false), isOpen = _c[0], setIsOpen = _c[1];
    function getUrl(picture) {
        return MediaManagerImage_1.getMediaManagerUrl(picture, 1000, 0, 'resize');
    }
    function changeImage() {
        onChangePhoto(getUrl(pictures[photoIndex]));
    }
    if (!pictures.length && renderEmpty) {
        return renderEmpty(props.data.type);
    }
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        isOpen && (react_1["default"].createElement(react_image_lightbox_1["default"], { mainSrc: getUrl(pictures[photoIndex]), nextSrc: pictures.length !== 1 &&
                getUrl(pictures[(photoIndex + 1) % pictures.length]), prevSrc: pictures.length !== 1 &&
                getUrl(pictures[(photoIndex + pictures.length - 1) % pictures.length]), onAfterOpen: changeImage(), onCloseRequest: function () { return setIsOpen(false); }, onMovePrevRequest: function () {
                setPhotoIndex((photoIndex + pictures.length - 1) % pictures.length);
                changeImage();
            }, onMoveNextRequest: function () {
                setPhotoIndex((photoIndex + 1) % pictures.length);
                changeImage();
            }, imageCaption: react_1["default"].createElement(react_1["default"].Fragment, null,
                pictures[photoIndex].author && (react_1["default"].createElement("div", null, "Autor: " + pictures[photoIndex].author)),
                pictures[photoIndex].source && (react_1["default"].createElement("div", null, "Zdroj: " + pictures[photoIndex].source))) })),
        react_1["default"].createElement(Section, null, pictures.map(function (img, idx) {
            var key = "img_" + idx;
            return (react_1["default"].createElement(Div, { key: key, style: imgs[idx]
                    ? {
                        width: (imgs[idx].w * SIZE) / imgs[idx].h + "px",
                        flexGrow: (imgs[idx].w * SIZE) / imgs[idx].h
                    }
                    : undefined },
                react_1["default"].createElement(I, { style: imgs[idx]
                        ? {
                            paddingBottom: (imgs[idx].h / imgs[idx].w) * 100 + "%"
                        }
                        : undefined }),
                react_1["default"].createElement(Img, { src: MediaManagerImage_1.getMediaManagerUrl(img, 400, 0, 'resize'), onClick: function () {
                        setPhotoIndex(idx);
                        setIsOpen(true);
                    }, onLoad: function (imgEl) {
                        setImgs(function (prevImgs) {
                            var _a;
                            return tslib_1.__assign(tslib_1.__assign({}, prevImgs), (_a = {}, _a[idx] = {
                                w: imgEl.naturalWidth,
                                h: imgEl.naturalHeight
                            }, _a));
                        });
                    } })));
        }))));
}
WidgetPhotoGallery.propTypes = {
    data: prop_types_1["default"].shape({
        type: prop_types_1["default"].string,
        pictures: prop_types_1["default"].arrayOf(prop_types_1["default"].shape()).isRequired
    }).isRequired,
    onChangePhoto: prop_types_1["default"].func,
    renderEmpty: prop_types_1["default"].func
};
WidgetPhotoGallery.defaultProps = {
    onChangePhoto: function () {
        //
    }
};
exports["default"] = WidgetPhotoGallery;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
